// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import "./plugins/base";
import "./plugins/chartist";
import "./plugins/vee-validate";
import "./plugins/vue-world-map";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VuetifyConfirm from "vuetify-confirm";
import VueCardFormat from "vue-credit-card-validation";

import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";

Vue.component("vue-draggable-resizable", VueDraggableResizable);

require("vue2-animate/dist/vue2-animate.min.css");
//service worker
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

// firebase
import "./plugins/auth/firebase.js";
import "./plugins/auth/fireauth.js";
// idle
import IdleVue from "idle-vue";

//drift
/* import VueDrift from 'vue-drift'

Vue.use(VueDrift, {
  appId: 'vmwiu7u8z76b',
  development: false,
}) */
//Analytics<

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "G-GCPCXF4GTQ",
  autoTracking: {
    screenview: true
  }
});
//Analytics>
// Quill editor
import VueQuillEditor from "vue-quill-editor";
Vue.use(VueQuillEditor);
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

/* MOMENT TO TAKE SNAPSHOTS OF THE TIME CREATED, ALSO HELPS TO SHOW THE TIME WHEN THE PUBLICATION WAS CREATED IN, Hours, days, months.. etc */
import moment from "moment";

import VueSweetalert2 from "vue-sweetalert2";

// Google maps
import * as VueGoogleMaps from "vue2-google-maps";

import "chartist/dist/chartist.min.css";
import * as ChartistTooltips from "chartist-plugin-tooltips";
import Vue2TouchEvents from "vue2-touch-events";
Vue.use(VueSocialSharing);

//social-share
import VueSocialSharing from "vue-social-sharing";

require("moment/locale/es");

//vue meta
import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDKCNiiLsmKRGo9E6UueE9sdZZArHJMJRU",
    libraries: "places",
    region: "co",
    language: "en"
  }
});
Vue.use(require("vue-moment"), {
  moment
});
Vue.use(require("vue-chartist"), {
  messageNoData: "You have not enough data",
  classNoData: "empty"
});
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: "Accept",
  buttonFalseText: "Discard",
  color: "error",
  icon: "mdi-alert",
  title: "CONFIRM",
  width: 350,
  property: "$confirm"
});

Vue.use(Vue2TouchEvents, {
  swipeTolerance: 20
});

Vue.use(VueCardFormat);

Vue.config.productionTip = false;
Vue.config.devtools = true;
const sweetAlertoptions = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674"
};

const eventsHub = new Vue();
/* Vue.config.errorHandler = function (err, vm, info) {
  // console.log(err, 'the error')
  // console.log(vm, 'the vm')
  // console.log(info, 'the info')
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
} */

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 7200000, // 2 hours,
  startAtIdle: false
});

Vue.use(VueSweetalert2, sweetAlertoptions);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
